export default __webpack_public_path__ + "6f22c560a8eaa854546c59d58d4073ae.svg";